import { composeIO } from 'react-compose-io'
import { controleHistoricoPerdasIO } from './ControleHistoricoPerdas.IO'
import { ControleHistoricoPerdasView } from './ControleHistoricoPerdas.View'

export const ControleHistoricoPerdas = composeIO(ControleHistoricoPerdasView, controleHistoricoPerdasIO)
